export default "__VITE_ASSET__434addd5__"